var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoReels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29932 2H11.5007L12.7667 5.165H8.56532L7.29932 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0194 6.835C14.0066 6.8353 13.9938 6.8353 13.9811 6.835H8.01945C8.00663 6.8353 7.99383 6.8353 7.98107 6.835H2V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6.835H14.0194ZM7.5 9.87052V15.1295C7.5 15.5154 7.91861 15.7558 8.25194 15.5614L12.7596 12.9319C13.0904 12.7389 13.0904 12.261 12.7596 12.0681L8.25194 9.43863C7.91861 9.24419 7.5 9.48462 7.5 9.87052Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2993 2L14.5653 5.165H18V4C18 2.89543 17.1046 2 16 2H13.2993Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50068 2H4C2.89543 2 2 2.89543 2 4V5.165H6.76668L5.50068 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoReels);
export default __webpack_public_path__ + "static/media/video-reels.81c895b72ff360fae06169413741cba9.svg";
export { ForwardRef as ReactComponent };